export class SubscriptionPlanCard extends HTMLElement {
  constructor() {
    super();
    this.optimzeBottomContainerHeight();
  }
  
  connectedCallback() {
    this.optimzeBottomContainerHeight();
    window.addEventListener('resize', this.optimzeBottomContainerHeight.bind(this));
  }

  optimzeBottomContainerHeight() {
    const topContainerHeight = parseInt(this.topContainer?.offsetHeight);
    if (isNaN(topContainerHeight)) return;
    if (window.screen.width > 749) {
      this.bottomContainer.style.height = `calc(100% - ${topContainerHeight}px)`;
    } else {
      this.bottomContainer.style.height = 'auto';
    }
  }

  get topContainer() {
    return this.querySelector('[ref="topContainer"]');
  }

  get bottomContainer() {
    return this.querySelector('[ref="bottomContainer"]');
  }
}

if (!customElements.get('subscription-plan-card')) {
  customElements.define('subscription-plan-card', SubscriptionPlanCard);
}